import React, { useState } from "react";
import SeatPlan from "./SeatPlan";
import TicketPrices from "./TicketPrices";
import HouseRules from "./HouseRules";
import "../../../styles/Tabs.scss";

interface Props {
  description: string;
  beneficiary?: string;
  organizer: string;
  mapUrl?: string;
  tickets: any[];
  rules: { id: string; rule: string }[];
  all_dates: string[] | null; 
}

const Tabs: React.FC<Props> = ({ description, beneficiary, organizer, mapUrl, tickets, rules, all_dates}) => {
  const [activeTab, setActiveTab] = useState("details");
  const hasSeatPlan = Boolean(mapUrl);

  const renderTabContent = () => {
    switch (activeTab) {
      case "details":
        return (
          <div className="tab-content">
            <h3>Description</h3>
            <p>{description}</p>
            {beneficiary && (
              <>
                <h3>Beneficiary</h3>
                <p>{beneficiary}</p>
              </>
            )}
            <h3>Organizer</h3>
            <p>{organizer}</p>
          </div>
        );
      case "seatplan":
         return hasSeatPlan ? <SeatPlan mapUrl={mapUrl} /> : null;
      case "tickets":
        return <TicketPrices tickets={tickets} all_dates={all_dates} />;
      case "rules":
        return <HouseRules rules={rules} />;
      default:
        return null;
    }
  };

  return (
    <div className="event-tabs">
      <div className="tab-buttons">
        <button
          className={activeTab === "details" ? "active" : ""}
          onClick={() => setActiveTab("details")}
        >
          Event Details
        </button>
        <button
         className={`seat-tab ${!hasSeatPlan ? "disabled" : ""} ${
            activeTab === "seatplan" ? "active" : ""
          }`}
          onClick={() => setActiveTab("seatplan")}
          disabled={!hasSeatPlan}
        >
          Seat Plan
        </button>
        <button
          className={activeTab === "tickets" ? "active" : ""}
          onClick={() => setActiveTab("tickets")}
        >
          Ticket Prices
        </button>
        <button
          className={`rules-tab ${(!rules || rules.length === 0) ? "disabled" : ""} ${
          activeTab === "rules" ? "active" : ""
        }`}
          onClick={() => setActiveTab("rules")}
          disabled={!rules || rules.length === 0}
        >
          House Rules and Guidelines
        </button>
      </div>
      {renderTabContent()}
    </div>
  );
};

export default Tabs;
